import React from 'react';

const info = (
  <img
    src={
      'https://www.paypalobjects.com/images/Cause/CampaignPage/info_icon.svg'
    }
  />
);

const close = (
  <img
    src={'https://www.paypalobjects.com/images/Cause/CampaignPage/ic_x.svg'}
  />
);

const error = (
  <img
    className={'iconStyling'}
    src='https://www.paypalobjects.com/images/Cause/icon-alert_XS.svg'
  />
);

const Icons = {
  info,
  close,
  error,
};

export default Icons;
